import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Edit, Times } from '../../../components/Icon';
import { Loader } from '../../../components/Loader';
import { HBox, VBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { List, Row } from '../../../components/List';
import { selectWorks } from '../../Api/selectors';
import { fetchUser } from '../../Users/actions';
import { setCompanyProperty } from '../actions';
import { getPropByName } from '../../../utils/props';
import { REQUEST_COMPANY_PROPERTY_UPDATE } from '../constants';
import { selectUser } from '../../Users/selectors';
import { REQUEST_USER } from '../../Users/constants';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import cn from 'classnames';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import styles from './CardRemarks.module.css';
import { Textarea } from '../../../components/Textarea';
import env from '../../../env';
import { AppClientId } from '../../Shared/constants';

dayjs.extend(customParseFormat);

const Container = styled.div`
  font-size: 1px;

  .icon-block {
    cursor: pointer;
    font-size: 22px;
  }

  .icon-cross {
    cursor: pointer;
    font-size: 18px;
    width: 20px;
    height: 22px;
  }

  .icon-edit-square {
    color: #0183d5;
  }

  .fa-square-xmark {
    padding: 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;

    background-color: #d50046;
    color: #fff;
  }

  align-items: center;

  .remark {
    margin-bottom: 10px;
    min-height: 60px;

    .initials-wrapper {
      width: 40px;
      height: 40px;
      background-color: rgba(29, 155, 209, 0.1);
      justify-content: center;
      border-radius: 50%;
    }

    .text {
      width: 85%;
      text-align: start;
    }
  }

  .text-input {
    width: 100%;
    height: 200px;
    resize: none;
  }
`;

const STATE = {
  isOpenAddModal: false,
  remarks: [],
  newRemarkText: '',
  editableRemark: null,
};
/* eslint-disable react/prefer-stateless-function */
class CompanyRemarksCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.handleModalOpen = this.handleModalOpen.bind(this);
  }

  componentDidMount() {
    this.props.company?.remarks && this.setState({ remarks: JSON.parse(this.props.company?.remarks) });
    this.props.fetch();
  }

  get remarkDate() {
    return dayjs(new Date(Date.now())).format('DD-MM-YYYY hh:mm');
  }

  handleModalOpen(remark = null) {
    this.setState({
      isOpenAddModal: true,
      editableRemark: remark?.id || null,
      newRemarkText: remark?.text || '',
    });
  }

  renderInitials(name, surname) {
    return (
      <HBox left vCenter>
        <HBox className="initials-wrapper" vCenter left>
          <strong>{name[0]?.toUpperCase()}</strong>
          <strong>{surname[0]?.toUpperCase()}</strong>
        </HBox>
        &nbsp;
        <strong>{name ?? ''}</strong>
        &nbsp;
        <strong>{surname ?? ''}</strong>
      </HBox>
    );
  }

  handleReset() {
    this.setState({
      isOpenAddModal: false,
      editableRemark: null,
      newRemarkText: '',
    });
  }

  handleSave() {
    const { loggedUser, setRemark } = this.props;
    const { newRemarkText, remarks } = this.state;

    const remark = {
      id: Date.now(),
      userId: loggedUser?.id,
      text: newRemarkText,
      name: getPropByName(loggedUser, 'name'),
      surname: getPropByName(loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const updatedRemarks = [...remarks, remark];

    setRemark(JSON.stringify(updatedRemarks), result => {
      if (result) {
        this.handleReset();
      }
    });
  }

  handleEdit(remarkId) {
    const { loggedUser, setRemark } = this.props;
    const { newRemarkText, remarks } = this.state;

    const remark = {
      id: remarkId,
      userId: loggedUser?.id,
      text: newRemarkText,
      name: getPropByName(loggedUser, 'name'),
      surname: getPropByName(loggedUser, 'surname'),
      date: this.remarkDate,
      sortingDate: this.sortingDate,
    };

    const filteredRemarks = remarks.filter(r => r?.id !== remarkId);
    const updatedRemarks = [...filteredRemarks, remark];

    setRemark(JSON.stringify(updatedRemarks));
    this.handleReset();
  }

  handleDelete(remarkId) {
    const { setRemark } = this.props;
    const { remarks } = this.state;

    const updatedRemarks = remarks.filter(remark => remark?.id !== remarkId);
    setRemark(JSON.stringify(updatedRemarks));
  }

  renderAddModal() {
    return (
      <ModalComponent
        title={this.state.editableRemark ? this.lbl('info.remarks.edit') : this.lbl('info.remarks.add')}
        onClose={this.handleReset}
      >
        <Textarea
          className="text-input"
          value={this.state.newRemarkText}
          onChange={e => this.setState({ newRemarkText: e.target?.value })}
        />

        <div className="d-flex gap-2 mt-2 justify-content-center">
          <ButtonComponent
            style={'ButtonSoftEdit'}
            disabled={this.props.work}
            onClick={
              this.state.editableRemark ? () => this.handleEdit(this.state.editableRemark) : this.handleSave.bind(this)
            }
          >
            {this.state.editableRemark ? this.lbl('confirm') : this.lbl('add')}
          </ButtonComponent>
          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.handleReset}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    if (this.props.work) return <Loader small />;

    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
        <List>
            {this.state.remarks?.map(remark => (
              <Row key={remark?.id}>
                <div className={styles.remarkCard}>
                  <HBox className="gap-2" vCenter right>
                    <ButtonComponent
                      style={'ButtonSoftEdit'}
                      disabled={env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id}
                      size={'btn-sm'}
                      onClick={() => {
                        if (env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id) {
                          return;
                        }
                        this.handleModalOpen(remark);
                      }}
                    >
                      <Edit />
                    </ButtonComponent>
                    <ButtonComponent
                      style={'ButtonSoftDelete'}
                      disabled={env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id}
                      size={'btn-sm'}
                      onClick={() => {
                        if (env.clientId === AppClientId.HOOIKAMMER && remark?.userId !== this.props.loggedUser?.id) {
                          return;
                        }
                        this.handleDelete(remark?.id);
                      }}
                    >
                      <Times />
                    </ButtonComponent>
                  </HBox>
                  <VBox className="remark" vCenter>
                    {remark?.name && remark?.surname && this.renderInitials(remark?.name, remark?.surname)}
                    <div className={styles.remarkText}>
                      <pre>
                        <h6>{remark?.text}</h6>
                      </pre>
                    </div>
                  </VBox>
                  <HBox right>{remark?.date}</HBox>
                </div>
              </Row>
            ))}
          </List>
          {this.state.isOpenAddModal && this.renderAddModal(this.state.isEdit)}
          <HBox>
            <h2>{this.lbl('info.remarks.title')}</h2>
            <ButtonComponent
              style={'ButtonSoftPrimary'}
              size={'btn-sm'}
              onClick={() => this.setState({ isOpenAddModal: true })}
            >
              {this.lbl('info.remarks.add')}
            </ButtonComponent>
          </HBox>
          
        </Container>
      </Card>
    );
  }
}

CompanyRemarksCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([REQUEST_COMPANY_PROPERTY_UPDATE, REQUEST_USER]),
    loggedUser: selectUser(ownProps?.loggedUserId),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchUser(ownProps?.loggedUserId));
    },
    setRemark(dto, callback) {
      dispatch(setCompanyProperty(ownProps?.company?.id, 'remarks', dto, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyRemarksCard = compose(withConnect, withRouter)(CompanyRemarksCardComp);
